import * as React from "react"

function CustomerIcon({ color }) {
    return (
        <svg
            width={25}
            height={18}
            viewBox="0 0 25 18"
        >
            <g fill="none" fillRule="evenodd">
                <path
                    fill={color}
                    fillRule="nonzero"
                    d="M18.334 11.32a3.23 3.23 0 00-3.226 3.227 3.23 3.23 0 003.226 3.227 3.23 3.23 0 003.227-3.227 3.23 3.23 0 00-3.227-3.227zm0 4.84a1.614 1.614 0 010-3.226c.89 0 1.614.723 1.614 1.613s-.724 1.613-1.614 1.613zM7.31 11.32a3.231 3.231 0 00-3.228 3.227 3.23 3.23 0 003.227 3.227 3.23 3.23 0 003.227-3.227 3.23 3.23 0 00-3.227-3.227zm0 4.84a1.614 1.614 0 111.613-1.613c0 .89-.724 1.613-1.614 1.613zM20.508 2.084a.808.808 0 00-.721-.445h-4.25v1.614h3.752l2.197 4.37 1.442-.726-2.42-4.813z"
                />
                <path
                    fill={color}
                    fillRule="nonzero"
                    d="M9.81 13.767h6.104v1.613H9.81zm-4.92 0H2.091a.806.806 0 000 1.614H4.89a.807.807 0 100-1.614zm19.54-4.932l-1.586-2.043a.806.806 0 00-.637-.312h-5.862V.833a.807.807 0 00-.807-.807H2.092a.806.806 0 000 1.613h12.64v5.647c0 .446.36.807.806.807h6.274l1.175 1.514v4.16h-2.232a.807.807 0 100 1.614h3.038a.807.807 0 00.807-.807V9.33a.809.809 0 00-.17-.495z"
                />
                <path
                    fill={color}
                    fillRule="nonzero"
                    d="M2.373 14.548V.001H.759v14.547a.807.807 0 001.614 0z"
                />
                <path
                    stroke={color}
                    strokeLinecap="round"
                    strokeWidth={1.3}
                    d="M5.304 7.355l1.882 2 4.767-4"
                />
            </g>
        </svg>
    )
}

export default CustomerIcon
